import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch, useStore } from "react-redux";
import { useHistory } from "react-router-dom";
import { selectFloatingChatVisible } from "../../../store/selector";
import ACTIONS from "../../../store/action";
import { FloatingChatButton } from "./FloatingChatButton";
import { FloatingChatPanel } from "./FloatingChatPanel";
import { FloatingChatView } from "./FloatingChatView";
import { useDashboardBucketsTrackingEventStable as useDashboardBucketsTrackingEvent } from "../../../utils/pendo/hooks";
import { PENDO_EVENTS } from "../Constants";

const FloatingChatWidget = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const store = useStore();
  const [newChatTrigger, setNewChatTrigger] = useState(false);
  const isPanelVisible = useSelector(selectFloatingChatVisible);
  const isStreamingRef = useRef(false);
  const { trackEvent } = useDashboardBucketsTrackingEvent();

  const handleButtonClick = () => {
    const newVisibility = !isPanelVisible;
    dispatch(ACTIONS.setFloatingChatVisible(newVisibility));

    if (newVisibility) {
      trackEvent(PENDO_EVENTS.CHAT_PANEL_EXPANDED);
    } else {
      trackEvent(PENDO_EVENTS.CHAT_PANEL_COLLAPSED);
    }
  };

  const handleStreamingStateChange = (isStreaming) => {
    isStreamingRef.current = isStreaming;
    dispatch(ACTIONS.setChatStreaming(isStreaming));
  };

  const handlePanelClose = () => {
    if (isStreamingRef.current) {
      dispatch(ACTIONS.setFloatingChatShouldLoadHistory(true));
    }
    dispatch(ACTIONS.setFloatingChatVisible(false));

    trackEvent(PENDO_EVENTS.CHAT_PANEL_COLLAPSED);
  };

  const handleExpand = () => {
    const state = store.getState();
    const { activeConversationId } = state.floatingChat;

    // Track Pendo event for expanding to full page
    trackEvent(PENDO_EVENTS.CHAT_EXPANDED_TO_FULL_PAGE);

    if (activeConversationId) {
      history.push(`/ai-chat-bot/conversations/${activeConversationId}/messages`);
    } else {
      dispatch(ACTIONS.setAiChatBotIntroPanelShown(true));
      history.push(`/ai-chat-bot/new`);
    }
    dispatch(ACTIONS.setFloatingChatVisible(false));
  };

  const handleNewChat = () => {
    dispatch(ACTIONS.setFloatingChatShouldLoadHistory(false));
    setNewChatTrigger(true);
  };

  useEffect(() => {
    if (newChatTrigger) {
      setNewChatTrigger(false);
    }
  }, [newChatTrigger]);

  return (
    <>
      {!isPanelVisible && <FloatingChatButton onClick={handleButtonClick} isActive={isPanelVisible} />}

      <FloatingChatPanel
        isVisible={isPanelVisible}
        onClose={handlePanelClose}
        onExpand={handleExpand}
        onNewChat={handleNewChat}
      >
        <FloatingChatView onNewChatTrigger={newChatTrigger} onStreamingStateChange={handleStreamingStateChange} />
      </FloatingChatPanel>
    </>
  );
};

export { FloatingChatWidget };
